export default __webpack_public_path__ + "static/media/Chocolate-Mousse.03e294ad.jpg";